export const ASSORTMENT_ADVISOR_SELECTED_DOOR_ID_PARAM_NAME = 'aa-doorId'
export const POSITIONINGS = ['young', 'innovative', 'sophisticated', 'sport', 'everyday']
export const CATEGORIES = ['sun', 'optical']
export const ASSORTMENT_SIZE_DEFAULT = 50
export const MAP_MIN_ZOOM = 12
export const MAP_INITIAL_ZOOM = 14.5
export const MAP_MAX_ZOOM = 16
